import { useState } from 'react';

import { SmallBoldUnderlinedTextDropdown } from '#src/components/SmallBoldUnderlinedTextDropdown/SmallBoldUnderlinedTextDropdown.tsx';
import { STATUS_CODES, type StatusCode } from './StatusCodes.ts';

export const useStatusCodeState = () => {
  const [statusCode, setStatusCode] = useState<StatusCode>('All');

  return {
    statusCode,
    setStatusCode,
  };
};

type Props = ReturnType<typeof useStatusCodeState>;

export const StatusCodePicker = ({ setStatusCode, statusCode }: Props) => (
  <SmallBoldUnderlinedTextDropdown
    setValue={setStatusCode}
    options={STATUS_CODES.map((status) => ({
      label: status,
      value: status,
    }))}
    value={statusCode}
  />
);
